(function($) {
    $(window).on("load", function() {
        // $('.featured-carousel .card-wrapper a').html("Read More");
        if ($(".js_featured_carousel_events, .featured-carousel").length > 0) {
            $(".my-feed-filter.double-slider .featured-carousel");
            setTimeout(function() {
                $(".my-feed-filter.double-slider").css({ 'opacity': 1 });
                if (
                    $(".my-feed-filter.double-slider .featured-carousel .card-wrapper")
                    .length > 2
                ) {
                    $(".my-feed-filter.double-slider .featured-carousel .row-wrap")
                        .not(".slick-initialized")
                        .slick({
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: false,
                            arrows: true,
                            autoplay: true,
                            autoplaySpeed: 6000,
                            speed: 2000,
                            infinite: true,
                            responsive: [{
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 1,
                                },
                            }, ],
                        });
                    //$(".featured-carousel.featured-carousel-view .card-wrapper").css("width", "auto");
                    var leftForArrow =
                        $(".featured-carousel .intro-block h4").outerWidth() + 16;
                    $(".featured-carousel .slick-arrow").css("left", leftForArrow);
                    $(".featured-carousel .slick-next").css("left", leftForArrow + 44);
                }
            }, 200);
            setTimeout(function() {
                $('.myhoover .my-feed .my-feed-filter .featured-carousel .card-img img').removeAttr('loading');
            }, 300);
        }
        setTimeout(function() {
            $(".my-feed-filter.double-slider").css({ 'opacity': 1 });
        }, 300);

        function applyTooltipInteraction() {
            $('.sticky-nav.with-dropdown li:has(.dropdown-list)').off('mouseenter mouseleave click');
            if ($(window).width() > 1024) {
                $('.sticky-nav.with-dropdown li:has(.dropdown-list)').on('mouseenter', function() {
                    $(this).addClass('rotate');
                }).on('mouseleave', function() {
                    $(this).removeClass('rotate');
                });
                $('.sticky-nav.with-dropdown .btn-wrapper .single-btn-wrap:has(.dropdown-list)').on('mouseenter', function() {
                    $(this).addClass('rotate');
                }).on('mouseleave', function() {
                    $(this).removeClass('rotate');
                });
            } else {
                $('.sticky-nav.with-dropdown li:has(.dropdown-list)').on('click', function() {
                    $(this).toggleClass('rotate');
                });
                $('.sticky-nav.with-dropdown .btn-wrapper .single-btn-wrap:has(.dropdown-list)').on('click', function() {
                    $(this).toggleClass('rotate');
                });
            }
        }
        applyTooltipInteraction();
        // $(window).on('resize', function() {
        //     applyDropdownInteraction();
        // });  
    });

    // accordian code
    $(document).on("click", ".accordian-head", function() {
        if ($(this).siblings(".accordian-body-outer").length > 0) {
            $(this).siblings(".accordian-body-outer").slideToggle(500);
            $(this).parent().toggleClass("active");
        }
    });
    $(document).on("click", ".accordian-head .check-box-wrap", function(e) {
        e.stopPropagation();
    });

    // checkbox sibling text
    $(document).on("mouseenter", ".accordian-head .check-box-wrap", function() {
        $(this).siblings(".info-text").css("opacity", "1");
    });
    $(document).on("mouseleave", ".accordian-head .check-box-wrap", function() {
        $(this).siblings(".info-text").css("opacity", "");
    });

    $(".checked").click(function() {
        if ($("#eiichiro-azuma").prop("checked") == true) {
            $(".fellow-card").removeClass("card-active");
            $(".my-feed-overlay").addClass("active");
        } else {
            $(".fellow-card").addClass("card-active");
            $(".my-feed-overlay").removeClass("active");
        }
    });
    $(document).on("click", ".my-feed-overlay .overlay-wrap", function(e) {
        e.stopPropagation();
        $(".my-feed-overlay").removeClass("active");
    });
    $(document).on("click", ".my-feed-overlay .overlay-wrap .my-feed-overlay-card ", function(e) {
        e.stopPropagation();
    });


    $(".my-feed-overlay .overlay-wrap .close-icon").on("click", function() {
        $(".my-feed-overlay").removeClass("active");
    });
})(jQuery);

(function($) {
    $(window).on("load resize orientationchange", function() {
        // $('.feed-carousel .card-wrapper a').html("Read More");
        if ($(".js_featured_carousel_events, .feed-carousel").length > 0) {
            $(".feed-carousel").css("opacity", "1");
            if (
                $(".my-feed-filter.double-slider .feed-carousel .card-wrapper").length >
                2
            ) {
                $(".my-feed-filter.double-slider .feed-carousel .row-wrap").not(".slick-initialized").slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true,
                    autoplay: true,
                    autoplaySpeed: 3000,
                    speed: 2000,
                    infinite: true,
                    responsive: [{
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                        },
                    }, ],
                });
                //$(".featured-carousel.featured-carousel-view .card-wrapper").css("width", "auto");
                var leftForArrow =
                    $(".feed-carousel .intro-block h4").outerWidth() + 16;

                $(".feed-carousel .slick-arrow").css("left", leftForArrow);
                $(".feed-carousel .slick-next").css("left", leftForArrow + 44);
            }
        }
    });
    $(window).on("load", function() {
        $(
            ".js_featured_research_publishedworkbyfellows .feed-carousel h4, .feed-carousel .card-wrapper h4"
        ).dotdotdot({
            height: 86,
            fallbackToLetter: true,
            watch: true,
        });
        $(
            ".js_featured_research_publishedworkbyfellows .feed-carousel .card-wrapper p, .feed-carousel .card-wrapper p"
        ).dotdotdot({
            height: 70,
            fallbackToLetter: true,
            watch: true,
        });
    });
    $(document).ready(function() {
        $("body .featured-carousel .author-detail .editor").dotdotdot({
            height: 25,
            fallbackToLetter: true,
            watch: true,
        });

        $(document).on("click keydown", function (e) {
          var clickedElement = e.target;
          if (
            $(clickedElement).hasClass("gray-overlay") ||
            $(clickedElement).hasClass("close") ||
            $(clickedElement).hasClass("container")
          ) {
            $("body").removeClass("overlay-bg");
          } else if (e.key === "Escape") {
            $("body").removeClass("overlay-bg");
          }
        });

        $('body.overlay-bg .my-feed .search-grid .tooltip .checkbox p').on('click', function() {
            $('body.overlay-bg .my-feed .search-grid .tooltip .checkbox p').removeClass('selected');
            $(this).addClass('selected');
        });

    });

    $(document).on("click", document, function(e) {
        $(
            "body.myhoover .my-bookmarks .filters-block.algolia-research .filter-wrapper .result--wrapper .sort-view "
        ).removeClass("active");
    });

    $(document).on(
        "click",
        "body.myhoover .my-bookmarks .filters-block.algolia-research .filter-wrapper .result--wrapper .sort-view ",
        function(event) {
            event.stopPropagation();
        }
    );
})(jQuery);